import React, { Component } from 'react';
import { Form, Input, Checkbox, message, Spin} from 'antd';
import { CognitoUserPool, CognitoUser, AuthenticationDetails } from 'amazon-cognito-identity-js';
import { Helmet } from "react-helmet";
import AWS from 'aws-sdk/global';
import Scroll from 'react-scroll';
import Cookie from 'js-cookie';

import { POOL_DATA, AWS_CONFIG_REGION, IDENTITY_POOL_ID, USERNAME_URL } from "../../../utils/config";

import { Link, withRouter } from 'react-router-dom';

import GetStarted from '../GetStarted'
import Sign from '../Sign';
import './Login.css'

class Login extends Component {

  state = {
    userNameStatus: '',
    userNameError: '',
    passWordStatus: '',
    passWordError: '',
    userName: '',
    visible: false,
    loading: false,
  };

  componentWillMount() {
    const userPool = new CognitoUserPool(POOL_DATA);

    const cognitoUser = userPool.getCurrentUser();

    if (cognitoUser !== null) {
      cognitoUser.getSession((err, session) => {
        if (err) {
          return;
        }
        if (session.isValid() === true) {
          this.props.history.push('/profile');
        }
      });
    }
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      this.setState({
        userNameStatus: '',
        userNameError: '',
        passWordStatus: '',
        passWordError: '',
      });

      if (/^[\w\W]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(values.username) && /[A-Z]/.test(values.username)) {
        this.setState({
          userNameStatus: 'error',
          userNameError: 'Email must be lowercase',
        });
        return;
      }

      if (values.username === undefined) {
        this.setState({
          userNameStatus: 'error',
          userNameError: 'Please input your Username / Email',
        });
        return;
      }

      if (values.password === undefined) {
        this.setState({
          passWordStatus: 'error',
          passWordError: 'Please input your Password',
        });
        return;
      }



      if (!err) {

        this.setState({
          loading: true,
        });

        const userPool = new CognitoUserPool(POOL_DATA);
        const userData = {
          Username : values.username,
          Pool : userPool,
        };

        const authenticationData = {
          Username : values.username,
          Password : values.password,
        };

        const cognitoUser = new CognitoUser(userData);
        const authenticationDetails = new AuthenticationDetails(authenticationData);

        cognitoUser.authenticateUser(authenticationDetails, {
          onSuccess: () => {
            //POTENTIAL: Region needs to be set if not already set previously elsewhere.
            AWS.config.region = AWS_CONFIG_REGION;
            AWS.config.credentials = new AWS.CognitoIdentityCredentials({
              IdentityPoolId : IDENTITY_POOL_ID,
            });

            // Remember a device
            if (values.remember === true) {
              cognitoUser.setDeviceStatusRemembered({
                onSuccess: () => {},
                onFailure: (err) => {
                  message.error(String(err));
                }
              });
            } else {
              cognitoUser.setDeviceStatusNotRemembered({
                onSuccess: () => {},
                onFailure: (err) => {
                  message.error(String(err));
                }
              });
            }
            this.setState({
              loading: false,
            });
            Cookie.set('qBatesUsername', cognitoUser.username);
            Cookie.set('qBatesEmail', values.username);
            message.success('Successfully Login');
            this.props.history.push('/profile');
          },

          onFailure: (err) => {
            if (String(err).indexOf('User') !== -1 || String(err).indexOf('password') !== -1) {
              if (String(err).indexOf('User does not exist') !== -1 ) {
                const userNameUrl = `${USERNAME_URL}?email=${values.username}`;
                fetch(userNameUrl, {
                  method: 'GET'
                })
                  .then(res => res.json())
                  .then((data) => {
                    const userData = {
                      Username : data.generatedUserName,
                      Pool : userPool,
                    };

                    const authenticationData = {
                      Username : data.generatedUserName,
                      Password : values.password,
                    };

                    const cognitoUser = new CognitoUser(userData);
                    const authenticationDetails = new AuthenticationDetails(authenticationData);

                    cognitoUser.authenticateUser(authenticationDetails, {
                      onSuccess: () => {
                        //POTENTIAL: Region needs to be set if not already set previously elsewhere.
                        AWS.config.region = AWS_CONFIG_REGION;
                        AWS.config.credentials = new AWS.CognitoIdentityCredentials({
                          IdentityPoolId : IDENTITY_POOL_ID,
                        });

                        // Remember a device
                        if (values.remember === true) {
                          cognitoUser.setDeviceStatusRemembered({
                            onSuccess: () => {},
                            onFailure: (err) => {
                              message.error(String(err));
                            }
                          });
                        } else {
                          cognitoUser.setDeviceStatusNotRemembered({
                            onSuccess: () => {},
                            onFailure: (err) => {
                              message.error(String(err));
                            }
                          });
                        }

                        this.setState({
                          loading: false,
                        });
                        message.success('Successfully Login');
                        this.props.history.push('/profile');
                      },
                      onFailure: (err) => {
                        if (String(err).indexOf('User is not confirmed') !== -1 ) {
                          this.setState({
                            loading: false,
                            userNameStatus: 'error',
                            userNameError: <span>It seems you haven't verify your email address. <a onClick={this.handleResend.bind(this, cognitoUser)}>Resend verification email</a></span>,
                          });
                        } else if (String(err).indexOf('User does not exist') !== -1 ) {
                          this.setState({
                            loading: false,
                            userNameStatus: 'error',
                            userNameError: <span>It seems you haven't registered yet. <Link to="/register">Sign up</Link>.</span>,
                          });
                        } else {
                          this.setState({
                            loading: false,
                            userNameStatus: 'error',
                            userNameError: <span>{String(err)}</span>,
                          });
                        }
                      }
                    });
                  });
              }
              if (String(err).indexOf('password') !== -1) {
                this.setState({
                  loading: false,
                  passWordStatus: 'error',
                  passWordError: 'Your Username/Email or Password is incorrect. Retry.',
                });
              }
            } else {
              message.error(String(err).split(': ')[1]);
            }
          },
        });
      }
    });
  };

  handleResend = (cognitoUser) => {
    this.setState({
      loading: true,
    });
    cognitoUser.resendConfirmationCode((err) => {
      if (err) {
        message.error(String(err).split(': ')[1]);
        return;
      }
      message.success('An email contains verification link has been sent to your registered email address');
      this.setState({
        loading: false,
        userNameStatus: 'error',
        userNameError: <span>Did not receive? <a onClick={this.handleResend.bind(this, cognitoUser)}>Resend</a></span>,
      });
    });
  };

  handleScroll = () => {
    Scroll.animateScroll.scrollTo(211, {
      duration: 800,
      smooth: 'easeOutQuad'
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <div className="Login">
        <Helmet>
          <title>Sign in - Qbates</title>
          <meta name="description" content="Sign in to Qbates" />
        </Helmet>
        <GetStarted/>
        <Sign/>
        <Spin spinning={this.state.loading}>
        <Form
          onSubmit={this.handleSubmit}
          className="login-form"
        >
          <Form.Item
            validateStatus={this.state.userNameStatus}
            help={this.state.userNameError}
            hasFeedback
          >
            <span>Username / Email</span>
            {getFieldDecorator('username', {
              rules: [
                { required: true, message: 'Please input your Username / Email' },
                { whitespace: true, message: 'Username or Email Should not contain whitespace'},
              ],
            })(
              <Input placeholder="Username / Email" onFocus={this.handleScroll.bind(this)}/>
            )}
          </Form.Item>
          <Form.Item
            validateStatus={this.state.passWordStatus}
            help={this.state.passWordError}
            hasFeedback
          >
            <span>Password</span>
            {getFieldDecorator('password', {
              rules: [{ required: true, message: 'Please input your Password' }],
            })(
              <Input type="password" placeholder="Password"/>
            )}
          </Form.Item>
          <Form.Item>
            {getFieldDecorator('remember', {
              valuePropName: 'checked',
              initialValue: true,
            })(
              <Checkbox>Remember me</Checkbox>
            )}
            <Link className="login-form-forgot" to="/forgot">Forgot password</Link>
          </Form.Item>
          <Form.Item className="login-button">
            <button>SIGN IN</button>
          </Form.Item>
        </Form>
        </Spin>
      </div>
    );
  }
}

const WrappedLogin = Form.create()(Login);
export default withRouter(WrappedLogin);


// WEBPACK FOOTER //
// ./src/Containers/GetStarted/components/Login.js